import uuidv4, {
    UuidGenerator
} from "./UuidGenerator";

export default class UuidV4Generator implements UuidGenerator {
    public generate() {
        return uuidv4();
    }
}
